import React from 'react';
import './AnswerOptions.css';

const AnswerOptions = ({ question, onAnswer, isAnswered }) => {
  const handleAnswerClick = (answerIndex) => {
    if (!isAnswered) {
      onAnswer(answerIndex);
    }
  };

  const renderTextAnswers = () => {
    return question.answers.map((answer, index) => (
      <button
        key={index}
        className={`answer-option text-answer ${isAnswered ? 'disabled' : ''}`}
        onClick={() => handleAnswerClick(index)}
        disabled={isAnswered}
      >
        <div className="answer-text">{answer}</div>
      </button>
    ));
  };

  const renderImageAnswers = () => {
    return question.answers.map((answer, index) => (
      <button
        key={index}
        className={`answer-option image-answer ${isAnswered ? 'disabled' : ''}`}
        onClick={() => handleAnswerClick(index)}
        disabled={isAnswered}
      >
        <div className="answer-image-container">
          <img 
            src={answer.image} 
            alt={answer.text}
            className="answer-image"
            onError={(e) => {
              e.target.src = 'https://placehold.co.com/200x150?text=صورة+غير+متوفرة';
            }}
          />
        </div>
        {/* <div className="answer-text">{answer.text}</div> */}
      </button>
    ));
  };

  return (
    <div className={`answer-options ${question.type === 'text-image' ? 'image-answers' : 'text-answers'}`}>
      {question.type === 'text-image' ? renderImageAnswers() : renderTextAnswers()}
    </div>
  );
};

export default AnswerOptions;
